/* global $ */

const POPUP_TIMEOUT = 6000

export default function () {
  const form = document.querySelector('form[action="/cart/add"]')
  const $cartCount = document.querySelector('[data-cart-count]')
  const $popupTemplate = document.getElementById('add-to-cart-popup')

  if (form == null) return

  form.addEventListener('submit', submit)

  function submit (event) {
    event.preventDefault()

    function success (json) {
      showPopup(json.product_title)
      updateCartCount()
    }

    function error (jqXHR) {
      if (jqXHR.status === 422) {
        const text = jqXHR.responseJSON.description
        alert(text)
        return
      }
      // Submit directly, let the server display the error
      form.submit()
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js', 
      data: $(form).serialize(), 
      dataType: 'json',
      success,
      error
    })

    function showPopup (title) {
      if ($popupTemplate == null) return

      let gone = false
      const $wrapper = document.createElement('div')
      const $el = $popupTemplate.content.cloneNode(true)
      const $title = $el.querySelector('[data-product-name]')
      const $button = $el.querySelector('[data-popup-close]')

      if ($title != null && title) {
        $title.textContent = title
      }
      if ($button != null) {
        $($button).one('click', () => {
          $wrapper.parentElement.removeChild($wrapper)
          gone = true
        })
        setTimeout(() => {
          if (gone) return
          $button.click()
        }, POPUP_TIMEOUT)
      }

      $wrapper.appendChild($el)
      document.body.appendChild($wrapper)
    }

    function updateCartCount () {
      if ($cartCount == null) return

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function update (json) {
          $cartCount.textContent = json.item_count
        }
      })
    }
  }
}
